import CloseIcon from "@mui/icons-material/Close";
import DoneIcon from "@mui/icons-material/Done";
import { Button } from "components";
import ModalWindow from "hooks/ModalWindow/ModalWindow";
import PinCode from "hooks/PinCode/PinCode";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  ChangePassword,
  ChangePin,
  ChangeProfileNumber,
  ChangeProfileEmail
} from "service/AuthService";
import {
  changePassword,
  changePhoneNumber,
  changePinCode,
  postMail
} from "store/slices/UserSlice";
import userInfo from "utils/userInfo";
import styles from "../PersonalMenu.module.scss";
import {
  checkPinCode,
} from "service/AuthService";

const PersonalInfo = ({
  title,
  data,
  phone,
  setPhone,
  email,
  setEmail,
  setNotify,
  icons,
  newPassword,
  setNewPassword,
  newPin,
  setNewPin,
  button,
  btnId,
}) => {
  const [pinCode, setPinCode] = useState();
  const [openModal, setOpenModal] = useState(false);

  const [file, setFile] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [emailUser, setEmailUser] = useState("");

  const [password, setPassword] = useState("");
  const [currentDynamicUser, getDynamic] = useState();
  const [EfficiencyColor, setEfficiencyColor] = useState("grey");
  const dispatch = useDispatch();
  const [backgroundImage, setBackgroundImg] = useState(null);
  const [pinOrComment, setPinOrComment] = useState(false);
  const user = userInfo();
  const navigate = useNavigate();
  const [userPinCode] = useState(user?.pin);

  const [successPin, setSuccessPin] = useState(false);

  const createUserPin = async () => {
    if (String(pinCode)?.length < 4 || !pinCode) {
      setNotify({
        isOpen: true,
        message: "Введите Пин!",
        type: "error",
        sound: "error",
      });
    } else if (String(pinCode).length === 4) {
      if (pinCode === user?.pin) {
        setOpenModal(false);
        setNotify({
          isOpen: true,
          message: "Задайте новый Пин!",
          type: "error",
          sound: "error",
        });
      } else {
        try {
          let response = await ChangePin(pinCode);
          dispatch(
            changePinCode({
              pin: pinCode,
            })
          );
          let userData = JSON.parse(localStorage.getItem('user'));

          userData.pin = pinCode;


          localStorage.setItem('user', JSON.stringify(userData));
          setNotify({
            isOpen: true,
            message: "Пин успешно изменен",
            type: "success",
            sound: "success",
          });

          setTimeout(() => {
            setOpenModal(true);
          }, 1000);


        } catch (error) {
          setNotify({
            isOpen: true,
            message: "Ошибка",
            type: "error",
            sound: "error",
          });
        }
      }
    }
  };

 const handleSubmit = async (event) => {
  event.preventDefault();

  if (!pinCode || String(pinCode).length < 4) {
    setNotify({
      isOpen: true,
      message: "Введите Пин!",
      type: "error",
      sound: "error",
    });
    return;
  }

  try {
    // Проверяем пин на сервере
    const pinCheckResponse = await checkPinCode(pinCode, user.userId);

    if (!pinCheckResponse.data.success) {
      setNotify({
        isOpen: true,
        message: "Неправильный Пин-Код",
        type: "error",
        sound: "error",
      });
      return;
    }

    setNotify({
      isOpen: true,
      message: "Верный Пин-Код!",
      type: "success",
      sound: "success",
    });

    setPinCode('');
    setPinOrComment(false);
    setSuccessPin(true);

    if (!password) {
      setNotify({
        isOpen: true,
        message: "Вы не указали новый пароль",
        type: "error",
        sound: "error",
      });
      return;
    }

    // Меняем пароль
    await ChangePassword(password);
    dispatch(changePassword({ new_password: password }));

    setNotify({
      isOpen: true,
      message: "Пароль успешно изменен",
      type: "success",
      sound: "success",
    });

    setTimeout(() => {
      window.location.reload();
    }, 500);

  } catch (error) {
    setNotify({
      isOpen: true,
      message: "Ошибка сервера. Попробуйте позже.",
      type: "error",
      sound: "error",
    });
  }
};


  const handleSubmit2 = async (event) => {
  event.preventDefault();

  if (!pinCode || String(pinCode).length < 4) {
    setNotify({
      isOpen: true,
      message: "Введите Пин!",
      type: "error",
      sound: "error",
    });
    return;
  }

  try {
    // Проверяем пин на сервере
    const pinCheckResponse = await checkPinCode(pinCode, user.userId);

    if (!pinCheckResponse.data.success) {
      setNotify({
        isOpen: true,
        message: "Неправильный Пин-Код",
        type: "error",
        sound: "error",
      });
      return;
    }

    setNotify({
      isOpen: true,
      message: "Верный Пин-Код!",
      type: "success",
      sound: "success",
    });

    setPinCode('');
    setPinOrComment(false);
    setSuccessPin(true);

    if (!phoneNumber) {
      setNotify({
        isOpen: true,
        message: "Вы не указали новый номер телефона",
        type: "error",
        sound: "error",
      });
      return;
    }

    // Меняем номер телефона
    await ChangeProfileNumber(phoneNumber);
    dispatch(changePhoneNumber({ numberPhone: phoneNumber }));

    setNotify({
      isOpen: true,
      message: "Номер телефона успешно изменен",
      type: "success",
      sound: "success",
    });

    setTimeout(() => {
      window.location.reload();
    }, 500);

  } catch (error) {
    setNotify({
      isOpen: true,
      message: "Ошибка сервера. Попробуйте позже.",
      type: "error",
      sound: "error",
    });
  }
};
const handleSubmit3 = async (event) => {
  event.preventDefault();

  if (!pinCode || String(pinCode).length < 4) {
    setNotify({
      isOpen: true,
      message: "Введите Пин!",
      type: "error",
      sound: "error",
    });
    return;
  }

  try {
    // Проверяем пин на сервере
    const pinCheckResponse = await checkPinCode(pinCode, user.userId);

    if (!pinCheckResponse.data.success) {
      setNotify({
        isOpen: true,
        message: "Неправильный Пин-Код",
        type: "error",
        sound: "error",
      });
      return;
    }

    setNotify({
      isOpen: true,
      message: "Верный Пин-Код!",
      type: "success",
      sound: "success",
    });

    setPinCode('');
    setPinOrComment(false);
    setSuccessPin(true);

    if (!emailUser) {
      setNotify({
        isOpen: true,
        message: "Вы не указали новый E-mail",
        type: "error",
        sound: "error",
      });
      return;
    }

    // Меняем email
    let response = await ChangeProfileEmail(emailUser);
    dispatch(postMail({ email: emailUser }));

    if (response?.data?.message) {
      setNotify({
        isOpen: true,
        message: response.data.message,
        type: "error",
        sound: "error",
      });
      setOpenModal(true);
      setEmail(false);
    } else {
      setNotify({
        isOpen: true,
        message: "E-mail успешно изменен",
        type: "success",
        sound: "success",
      });
      setTimeout(() => {
        window.location.reload();
      }, 500);
    }

  } catch (error) {
    setNotify({
      isOpen: true,
      message: "Ошибка сервера. Попробуйте позже.",
      type: "error",
      sound: "error",
    });
  }
};
  const [isExpanded, setIsExpanded] = useState(false);

  const handleClickImg = () => {
    setIsExpanded(!isExpanded);
  };

  const pinLogIn = async () => {
  if (String(pinCode).length !== 4) {
    setNotify({
      isOpen: true,
      message: "Введите 4-значный ПИН-код",
      type: "warning",
      sound: "error",
    });
    return;
  }

  try {
    const response = await checkPinCode(pinCode, user.userId); // user.id — id пользователя
    if (response.data.success) {
      setNotify({
        isOpen: true,
        message: "Верный Пин-Код!",
        type: "success",
        sound: "success",
      });

      setPinOrComment(true);
      setPinCode(null);
    } else {
      setNotify({
        isOpen: true,
        message: "Неправильный Пин-Код",
        type: "error",
        sound: "error",
      });
    }
  } catch (error) {
    setNotify({
      isOpen: true,
      message: "Ошибка сервера. Попробуйте позже.",
      type: "error",
      sound: "error",
    });
  }
};

  const handleClosePhone = () => {
    setOpenModal(true);
    setPhone(false);
  };
  const handleCloseEmail = () => {
    setOpenModal(true);
    setEmail(false);
  };

  const handleClosePin = () => {
    setOpenModal(true);
    setNewPin(false);
  };

  return (
    <>
      {phone && phone !== undefined ? (
        <div>
          {pinOrComment ? (
            <ModalWindow
              openModal={!openModal}
              setOpenModal={setOpenModal}
              modalText={"Введите ПИН-код"}
              width={"unset"}
            >
              <>
                <PinCode setPinCode={setPinCode} passwordVisible={false} />
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <Button
                    onClick={handleClosePhone}
                    className={styles.btn_pin_close}
                  >
                    {" "}
                    Закрыть
                  </Button>
                  <Button onClick={handleSubmit2} className={styles.btn_pin}>
                    Подтвердить
                  </Button>
                </div>
              </>
            </ModalWindow>
          ) : (
            <div className={styles.PersonalInfo}>
              <input
                type="number"
                maxLength={2}
                onChange={(e) => setPhoneNumber(e.target.value)}
                className={styles.password_change}
                placeholder="Введите номер телефона"
                style={{
                  WebkitAppearance: "none", // for Webkit browsers (e.g., Chrome, Safari)
                  appearance: "none", // for other browsers
                }}
                onKeyDown={(e) => {
                  if (e.target.value.length >= 12 && e.key !== "Backspace") {
                    e.preventDefault();
                  }
                }}
              />
              <div>
                <button
                  className={styles.btn2}
                  style={{ border: "none" }}
                  onClick={() => setPhone(false)}
                >
                  <CloseIcon sx={{ fontSize: "20px" }} />
                </button>
                <Button
                  className={styles.btn2}
                  onClick={() => setPinOrComment(true)}
                >
                  <DoneIcon />
                </Button>
              </div>
            </div>
          )}
        </div>
      ) : newPassword ? (
        <div>
          {pinOrComment ? (
            <ModalWindow
              openModal={!openModal}
              setOpenModal={setOpenModal}
              modalText={"Введите ПИН-код"}
              width={"unset"}
            >
              <>
                <PinCode setPinCode={setPinCode} passwordVisible={false} />
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <Button
                    onClick={() => setOpenModal(true)}
                    className={styles.btn_pin_close}
                  >
                    {" "}
                    Закрыть
                  </Button>
                  <Button onClick={handleSubmit} className={styles.btn_pin}>
                    Подтвердить
                  </Button>
                </div>
              </>
            </ModalWindow>
          ) : (
            <div className={styles.PersonalInfo}>
              <input
                type="password"
                onChange={(e) => setPassword(e.target.value)}
                className={styles.password_change}
                placeholder="Введите новый пароль"
              />
              <button
                className={styles.btn2}
                style={{ border: "none" }}
                onClick={() => setNewPassword(false)}
              >
                <CloseIcon sx={{ fontSize: "20px" }} />
              </button>
              <Button
                className={styles.btn2}
                onClick={() => setPinOrComment(true)}
              >
                <DoneIcon />
              </Button>
            </div>
          )}
        </div>
      ) : newPin ? (
        <div>
          {pinOrComment ? (
            <ModalWindow
              openModal={!openModal}
              setOpenModal={setOpenModal}
              modalText={"Введите новый ПИН-код"}
            >
              <>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                  }}
                >
                  <PinCode setPinCode={setPinCode} passwordVisible={false} />
                  <Button
                    onClick={handleClosePin}
                    className={styles.btn_pin_close}
                  >
                    {" "}
                    Закрыть
                  </Button>
                  <Button onClick={createUserPin} className={styles.btn_pin}>
                    Подтвердить
                  </Button>
                </div>
              </>
            </ModalWindow>
          ) : (
            <ModalWindow
              openModal={!openModal}
              setOpenModal={setOpenModal}
              modalText={"Введите старый ПИН-код"}
              width={"unset"}
            >
              <>
                <PinCode setPinCode={setPinCode} passwordVisible={false} />
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <Button
                    onClick={handleClosePin}
                    className={styles.btn_pin_close}
                  >
                    {" "}
                    Закрыть
                  </Button>
                  <Button onClick={pinLogIn} className={styles.btn_pin}>
                    Подтвердить
                  </Button>
                </div>
              </>
            </ModalWindow>
          )}
        </div>
      ) : email && email !== undefined ? (
        <div>
          {pinOrComment ? (
            <ModalWindow
              openModal={!openModal}
              setOpenModal={setOpenModal}
              modalText={"Введите ПИН-код"}
              width={"unset"}
            >
              <>
                <PinCode setPinCode={setPinCode} passwordVisible={false} />
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <Button
                    onClick={handleCloseEmail}
                    className={styles.btn_pin_close}
                  >
                    {" "}
                    Закрыть
                  </Button>
                  <Button onClick={handleSubmit3} className={styles.btn_pin}>
                    Подтвердить
                  </Button>
                </div>
              </>
            </ModalWindow>
          ) : (
            <div className={styles.PersonalInfo}>
              <input
                type="email"
                // maxLength={20}
                onChange={(e) => setEmailUser(e.target.value)}
                className={styles.password_change}
                placeholder="Введите новый E-mail"
                style={{
                  WebkitAppearance: "none", // for Webkit browsers (e.g., Chrome, Safari)
                  appearance: "none", // for other browsers
                }}
                onKeyDown={(e) => {
                  if (e.target.value.length >= 50 && e.key !== "Backspace") {
                    e.preventDefault();
                  }
                }}
              />
              <div>
                <button
                  className={styles.btn2}
                  style={{ border: "none" }}
                  onClick={() => setEmail(false)}
                >
                  <CloseIcon sx={{ fontSize: "20px" }} />
                </button>
                <Button
                  className={styles.btn2}
                  onClick={() => setPinOrComment(true)}
                >
                  <DoneIcon />
                </Button>
              </div>
            </div>
          )}
        </div>
      ) : (

        <div className={styles.PersonalInfo}>
          <span style={{ display: "flex", alignItems: "center" }}>
            <span style={{ display: "flex", color: "gray" }}>{icons}</span>
            {title}
          </span>
          <span>
            {data}
            {button !== undefined ? (
              <button
                id={btnId ? styles.btnId : null}
                className={styles.btn_change}
                onClick={() => {
                  button(true);
                }}
              >
                Изменить
              </button>
            ) : null}
          </span>
        </div>
      )}
    </>
  );
};

export default PersonalInfo;
